import { ca } from '@cian/analytics';

export const trackBookingClick = (label: string) => {
  ca('eventSite', {
    action: 'click_booked',
    category: 'builders_booked',
    name: 'oldevent',
    label,
    useLastProducts: true,
  });
};
